import type { SubscribeAction, SubscribeActionWithArgs } from '../types';
import type { ReduxAction } from 'app/redux/types';

import type { BackendEntities } from 'app/lib/betting/betting-entities';

import type { SubscriptionsExtArgs } from '../../hub/main-hub';

// ---

export const MATCHES_TOPIC_PREFIX = 'matches-topic';

// ---

export const SUBSCRIBE_TO_MATCHES = 'WEB_SOCKETS:SUBSCRIBE_TO_MATCHES';

export type SubscribeToMatches = SubscribeActionWithArgs<
  typeof SUBSCRIBE_TO_MATCHES,
  Pick<SubscriptionsExtArgs, 'Matches'>
>;

export const subscribeToMatches = (
  topic: string,
  matchIds: number[],
): SubscribeToMatches => ({
  type: SUBSCRIBE_TO_MATCHES,
  args: {
    Matches: matchIds,
  },
  payload: {
    topic: `${MATCHES_TOPIC_PREFIX}__${topic}`,
  },
});

// ---

export const UNSUBSCRIBE_FROM_MATCHES = 'WEB_SOCKETS:UNSUBSCRIBE_FROM_MATCHES';

export type UnsubscribeFromMatches = SubscribeAction<typeof UNSUBSCRIBE_FROM_MATCHES>;

export const unsubscribeFromMatches = (topic: string): UnsubscribeFromMatches => ({
  type: UNSUBSCRIBE_FROM_MATCHES,
  payload: {
    topic: `${MATCHES_TOPIC_PREFIX}__${topic}`,
  },
});

// ---

export const APPLY_MATCHES = 'WEB_SOCKETS:APPLY_MATCHES';

export type ApplyMatches = ReduxAction<
  typeof APPLY_MATCHES,
  BackendEntities
>;

export const applyMatches = (payload: BackendEntities): ApplyMatches => ({
  type: APPLY_MATCHES,
  payload,
});
